import { useState, useEffect } from "react"

const getOption = (selectedType, options) => {
  const selectedOption = options.find((option) => option.id === selectedType)
  return selectedOption || options[0]
}

const useOption = (selectedType, options) => {
  const [option, setOption] = useState(getOption(selectedType, options))

  useEffect(() => {
    setOption(getOption(selectedType, options))
  }, [selectedType, options])

  return [option, setOption]
}

export default useOption
